module.exports = __webpack_public_path__ + "static/media/img_marathon_L.ffde4403.svg";